import { useCallback, useEffect } from "react";
import { MessagesService } from "../../../../../../../services/messages";

export const useReadConversation = (conversationId: string | undefined) => {
  const read = useCallback(async (id: string) => {
    try {
      await MessagesService.read(id);
    } catch {}
  }, []);

  useEffect(() => {
    if (conversationId) {
      read(conversationId);
    }
  }, [conversationId, read]);
};
